import type React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@shadeables/supabase';

const PublicRoute: React.FC = () => {
  const { user } = useAuth();

  if (user) {
    return <Navigate to="/dashboard" />;
  }

  return <Outlet />;
};

export default PublicRoute;
